import { render, staticRenderFns } from "./wycShowBox.vue?vue&type=template&id=62ee3b27&scoped=true&"
import script from "./wycShowBox.vue?vue&type=script&lang=js&"
export * from "./wycShowBox.vue?vue&type=script&lang=js&"
import style0 from "./wycShowBox.vue?vue&type=style&index=0&id=62ee3b27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ee3b27",
  null
  
)

export default component.exports